import {
  BusinessFields,
  Categories,
  ContactFields,
  ExcludeFromConfirmationMail,
  Root,
} from './components';

export const CompanyLinkForm = {
  Root,
  BusinessFields,
  ContactFields,
  Categories,
  ExcludeFromConfirmationMail,
};
